import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="bg-white text-slate-800 min-h-screen">
      {/* Estilos locales mínimos */}
      <style>{`
        :root{
          --brand:#244A9B;
          --brand-soft:#9EC2FF;
          --ink:#0F1D43;
        }
        .soft{box-shadow:0 12px 30px rgba(15,29,67,.06),0 6px 14px rgba(15,29,67,.05)}
        .nav-link{font-size:.95rem;font-weight:700;letter-spacing:.02em;color:#475569}
        .nav-link:hover{color:#0f172a}
      `}</style>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-24 flex items-center justify-between">
            {/* Logo → SPA */}
            <Link to="/" className="flex items-center gap-3" aria-label="Inicio Promequi">
              <img src="/assets/logo.png" alt="Logo Promequi" className="h-10 w-auto sm:h-12 md:h-16 lg:h-24" />
            </Link>
            <nav className="hidden md:flex items-center gap-8">
              <Link className="nav-link" to="/">HOME</Link>
              <Link className="nav-link" to="/catalogo">CATÁLOGO</Link>
            </nav>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setMobileOpen((v) => !v)}
                className="md:hidden p-2 rounded-lg border border-slate-200"
                aria-label="Abrir menú"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 6h16M4 12h16M4 18h16"/>
                </svg>
              </button>
            </div>
          </div>
          {mobileOpen && (
            <div className="md:hidden pb-4" id="mobileNav">
              <div className="flex flex-col gap-3 text-sm">
                <Link to="/" className="py-2" onClick={() => setMobileOpen(false)}>HOME</Link>
                <Link to="/catalogo" className="py-2" onClick={() => setMobileOpen(false)}>CATÁLOGO</Link>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Hero */}
      <section className="py-10 lg:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" style={{ color: "var(--ink)" }}>
            Política de Privacidad
          </h1>
          <p className="text-slate-600 mt-2">Última actualización: Enero 2026</p>
        </div>
      </section>

      {/* Contenido */}
      <section className="pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            
            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              1. Introducción
            </h2>
            <p className="text-slate-600 mb-4">
              En Promequi, respetamos su privacidad y nos comprometemos a proteger sus datos personales. 
              Esta política de privacidad le informará sobre cómo cuidamos sus datos personales cuando 
              visita nuestro sitio web o utiliza nuestra aplicación móvil, y le informará sobre sus 
              derechos de privacidad y cómo la ley lo protege.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              2. Datos que Recopilamos
            </h2>
            <p className="text-slate-600 mb-4">
              Podemos recopilar, usar, almacenar y transferir diferentes tipos de datos personales sobre usted:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li><strong>Datos de identidad:</strong> nombre, apellido, nombre de usuario o identificador similar.</li>
              <li><strong>Datos de contacto:</strong> dirección de correo electrónico, números de teléfono, dirección de entrega.</li>
              <li><strong>Datos de transacción:</strong> detalles sobre pedidos y pagos realizados.</li>
              <li><strong>Datos técnicos:</strong> dirección IP, tipo de navegador, zona horaria, ubicación.</li>
              <li><strong>Datos de perfil:</strong> su nombre de usuario, compras realizadas, preferencias.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              3. Cómo Usamos sus Datos
            </h2>
            <p className="text-slate-600 mb-4">
              Utilizamos sus datos personales para los siguientes propósitos:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Procesar y entregar sus pedidos.</li>
              <li>Gestionar su cuenta y relación con nosotros.</li>
              <li>Enviar notificaciones sobre su pedido o cuenta.</li>
              <li>Mejorar nuestros productos, servicios y experiencia del usuario.</li>
              <li>Recomendarle productos o servicios que puedan interesarle.</li>
              <li>Cumplir con obligaciones legales.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              4. Seguridad de los Datos
            </h2>
            <p className="text-slate-600 mb-4">
              Hemos implementado medidas de seguridad apropiadas para evitar que sus datos personales 
              se pierdan accidentalmente, se usen o accedan de forma no autorizada, se alteren o divulguen. 
              Además, limitamos el acceso a sus datos personales a aquellos empleados, agentes, contratistas 
              y otros terceros que tengan una necesidad comercial de conocerlos.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              5. Retención de Datos
            </h2>
            <p className="text-slate-600 mb-4">
              Solo conservaremos sus datos personales durante el tiempo que sea necesario para cumplir 
              con los propósitos para los que los recopilamos, incluyendo el cumplimiento de requisitos 
              legales, contables o de informes.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              6. Sus Derechos
            </h2>
            <p className="text-slate-600 mb-4">
              Bajo ciertas circunstancias, usted tiene derechos según las leyes de protección de datos en relación con sus datos personales:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li><strong>Derecho de acceso:</strong> solicitar una copia de sus datos personales.</li>
              <li><strong>Derecho de rectificación:</strong> corregir datos incorrectos o incompletos.</li>
              <li><strong>Derecho de eliminación:</strong> solicitar la eliminación de sus datos personales.</li>
              <li><strong>Derecho a retirar el consentimiento:</strong> en cualquier momento donde dependamos del consentimiento para procesar sus datos.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              7. Uso de la Aplicación Móvil
            </h2>
            <p className="text-slate-600 mb-4">
              Nuestra aplicación móvil puede solicitar acceso a ciertas funciones de su dispositivo, como:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li><strong>Cámara:</strong> para escanear códigos o subir fotos de productos/comprobantes.</li>
              <li><strong>Ubicación:</strong> para facilitar entregas y mostrar tiendas cercanas.</li>
              <li><strong>Notificaciones:</strong> para enviarle actualizaciones sobre sus pedidos.</li>
              <li><strong>Almacenamiento:</strong> para guardar datos de la aplicación localmente.</li>
            </ul>
            <p className="text-slate-600 mb-4">
              Puede gestionar estos permisos en la configuración de su dispositivo en cualquier momento.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              8. Cookies
            </h2>
            <p className="text-slate-600 mb-4">
              Utilizamos cookies y tecnologías similares para mejorar su experiencia en nuestro sitio web, 
              analizar el tráfico y personalizar el contenido. Puede configurar su navegador para rechazar 
              todas o algunas cookies, o para que le avise cuando los sitios web configuren o accedan a cookies.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              9. Cambios a Esta Política
            </h2>
            <p className="text-slate-600 mb-4">
              Podemos actualizar esta política de privacidad de vez en cuando. Le notificaremos sobre 
              cualquier cambio publicando la nueva política de privacidad en esta página y actualizando 
              la fecha de "última actualización" en la parte superior.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: "var(--ink)" }}>
              10. Contacto
            </h2>
            <p className="text-slate-600 mb-4">
              Si tiene preguntas sobre esta política de privacidad o nuestras prácticas de privacidad, 
              por favor contáctenos:
            </p>
            <ul className="list-none text-slate-600 mb-4 space-y-2">
              <li><strong>Email:</strong> info@promequi.com.gt</li>
              <li><strong>WhatsApp:</strong> +502 5978-6302</li>
              <li>
                <strong>Página de contacto:</strong>{" "}
                <Link to="/contacto" className="text-blue-600 hover:underline">
                  www.promequi.com.gt/contacto
                </Link>
              </li>
            </ul>

          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Promequi. Todos los derechos reservados.</p>
          <div className="mt-4 flex justify-center gap-6">
            <Link to="/" className="hover:text-slate-700">Inicio</Link>
            <Link to="/catalogo" className="hover:text-slate-700">Catálogo</Link>
            <Link to="/contacto" className="hover:text-slate-700">Contacto</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
